import firebase from 'firebase/app'

export const firebase_config = {
  apiKey: process.env.VUE_APP_FB_API_KEY,
  authDomain: process.env.VUE_APP_FB_AUTH_DOMAIN,
  projectId: process.env.VUE_APP_FB_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FB_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FB_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FB_APP_ID,
  measurementId: process.env.VUE_APP_FB_MEASUREMENT_ID
}

export const firebase_ui_config = () => {
  return {
    signInFlow: 'popup',
    callbacks: {
      signInSuccessWithAuthResult: (user, credential, redirectUrl) => {
        return false
      }
    },
    signInOptions: [
      firebase.auth.GoogleAuthProvider.PROVIDER_ID,
      firebase.auth.TwitterAuthProvider.PROVIDER_ID,
      firebase.auth.GithubAuthProvider.PROVIDER_ID,
      firebase.auth.EmailAuthProvider.PROVIDER_ID
    ],
    tosUrl: '/#tos',
    privacyPolicyUrl: '/#privacy'
  }
}

export const init_firebase = (router, auth_change_handler) => {
  if(!firebase.apps || !firebase.apps.length) {
    firebase.initializeApp(firebase_config)
  }

  firebase.auth().onAuthStateChanged(auth_change_handler)
  firebase.analytics()
  return firebase.auth()
}
